var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"90971f668211f10ffe3d094eef4c532880a494c7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["alliance-farmers-portal@webtools-agri"]={id:"90971f668211f10ffe3d094eef4c532880a494c7"};
      